import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestSection() {
  const latest = [...comics]
    .filter((c) => c.status === 'ongoing')
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500">最新更新的漫画章节，精彩不容错过</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}